import { RestrictionType } from '../store/model/store.model';

export const checkBlockedLineRestriction = (restrictions: RestrictionType[]) =>
    restrictions.some((restriction) => restriction.restrictionType === 'ROBBERY' && restriction.active);

export const getBlockLineRestrictionId = (restrictions: RestrictionType[]) =>
    restrictions.find((restriction) => restriction.restrictionType === 'ROBBERY')?.restrictionSpecId;
